/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { reactive, watch } from 'vue';
import { d as dayjs } from '../../_chunks/dep-99a0abba.mjs';
import '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import { createDefaultCurDate } from '../utils.mjs';
import { i as isArray_1 } from '../../_chunks/dep-b9567f6a.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

function useState(props) {
  var _useConfig = useConfig(COMPONENT_NAME),
    globalConfig = _useConfig.globalConfig;
  var state = reactive({
    realFirstDayOfWeek: 1,
    curDate: null,
    curDateList: [],
    curSelectedYear: null,
    curSelectedMonth: null,
    curSelectedMode: null,
    isShowWeekend: true,
    controlSize: "medium"
  });
  function toToday() {
    var curDate = createDefaultCurDate();
    state.curSelectedYear = curDate.year();
    state.curSelectedMonth = parseInt(curDate.format("M"), 10);
  }
  function setCurSelectedYear(year) {
    var curSelectedYear = year ? parseInt("".concat(year), 10) : createDefaultCurDate().year();
    if (!isNaN(curSelectedYear) && curSelectedYear > 0) {
      state.curSelectedYear = curSelectedYear;
    }
  }
  function setCurSelectedMonth(month) {
    var curSelectedMonth = month ? parseInt("".concat(month), 10) : parseInt(createDefaultCurDate().format("M"), 10);
    if (!isNaN(curSelectedMonth) && curSelectedMonth > 0 && curSelectedMonth <= 12) {
      state.curSelectedMonth = curSelectedMonth;
    }
  }
  function setCurrentDate(value) {
    if (isArray_1(value)) {
      state.curDate = value && value.length ? dayjs(value[0]) : createDefaultCurDate();
    } else {
      state.curDate = value ? dayjs(value) : createDefaultCurDate();
    }
  }
  function setCurrentDateList(value) {
    if (isArray_1(value)) {
      state.curDateList = value && value.length ? value.map(function (item) {
        return dayjs(item);
      }) : [createDefaultCurDate()];
    } else {
      state.curDateList = value ? [dayjs(value)] : [createDefaultCurDate()];
    }
  }
  function checkDayVisible(day) {
    var re = true;
    if (!state.isShowWeekend) {
      re = day !== 6 && day !== 7;
    }
    return re;
  }
  watch(function () {
    return props.firstDayOfWeek;
  }, function () {
    var _ref, _props$firstDayOfWeek;
    state.realFirstDayOfWeek = (_ref = (_props$firstDayOfWeek = props.firstDayOfWeek) !== null && _props$firstDayOfWeek !== void 0 ? _props$firstDayOfWeek : globalConfig.value.firstDayOfWeek) !== null && _ref !== void 0 ? _ref : 1;
  }, {
    immediate: true
  });
  watch(function () {
    return props.value;
  }, function (v) {
    if (props.multiple) {
      setCurrentDateList(v);
    } else {
      setCurrentDate(v);
    }
  }, {
    immediate: true
  });
  watch(function () {
    return props.year;
  }, function (v) {
    setCurSelectedYear(v);
  }, {
    immediate: true
  });
  watch(function () {
    return props.month;
  }, function (v) {
    setCurSelectedMonth(v);
  }, {
    immediate: true
  });
  watch(function () {
    return props.isShowWeekendDefault;
  }, function (v) {
    state.isShowWeekend = v;
  }, {
    immediate: true
  });
  watch(function () {
    return props.mode;
  }, function (v) {
    state.curSelectedMode = v;
  }, {
    immediate: true
  });
  watch(function () {
    return props.theme;
  }, function (v) {
    if (v === "card") state.controlSize = "small";
    if (v === "full") state.controlSize = "medium";
  }, {
    immediate: true
  });
  return {
    state: state,
    toToday: toToday,
    checkDayVisible: checkDayVisible
  };
}

export { useState };
//# sourceMappingURL=useState.mjs.map
